import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        blok: {
            type: Object,
            default: () => null
        }
    }
});
